function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
  id: "broadband-device-hi-dark_svg__a",
  "data-name": "Broadband_ic_hi 2",
  viewBox: "0 0 192 192"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h192v192H0z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 16,
  width: 160,
  height: 160,
  rx: 80,
  ry: 80,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "ICON"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "<Pfad>",
  cx: 96,
  cy: 118,
  r: 8,
  fill: "#4a4d4e"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M54.17 79.37a59.13 59.13 0 0183.66 0M66.28 90a42.25 42.25 0 0159.77 0M78.72 99.18a24.58 24.58 0 0134.73 0",
  fill: "none",
  stroke: "#e60000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M96 174a80.23 80.23 0 01-80-79v1a80.24 80.24 0 0080 80 80.24 80.24 0 0080-80v-1a80.23 80.23 0 01-80 79z",
  opacity: 0.06
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Broadband_device_ic"
}, /*#__PURE__*/React.createElement("use", {
  "data-name": "Broadband_ic_hi 2",
  width: 192,
  height: 192,
  xlinkHref: "#broadband-device-hi-dark_svg__a"
}));

var SvgBroadbandDeviceHiDark = function SvgBroadbandDeviceHiDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref, _ref2);
};

export default SvgBroadbandDeviceHiDark;